import React from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import * as Colors from "../Colors";
import { sortData, getDistinct } from "./ChartHelper";

export default function ScatterWeighted({ data, options }) {
  data = data ? data : [];
  data = sortData(data, options);

  const fontSize =
    options.fontSize ?? getDistinct(data, "name").size > 6
      ? "1.2rem"
      : "1.4rem";
  const xDomain = options.xDomain ? options.xDomain : [0, options.xMax];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ScatterChart
        margin={{
          top: 30,
          right: 20,
          left: 40,
          bottom: 30,
        }}
      >
        <XAxis
          type={options.xType}
          allowDuplicatedCategory={false}
          dataKey="name"
          domain={xDomain}
          name={options.xLabel}
          label={{
            value: options.xLabel,
            fill: Colors.PURPLE,
            position: "insideBottom",
            offset: -15,
          }}
          tick={{ fontSize: fontSize }}
          stroke={Colors.PURPLE}
          minTickGap={20}
          interval={0}
        />
        <YAxis
          type={options.yType}
          allowDuplicatedCategory={false}
          dataKey="value"
          domain={[0, options.yMax]}
          name={options.yLabel}
          label={{
            value: options.yLabel,
            fill: Colors.PURPLE,
            position: "center",
            angle: -90,
            dx: -50,
          }}
          tick={{ fontSize: fontSize }}
          stroke={Colors.PURPLE}
        />
        <ZAxis
          type="number"
          dataKey="amount"
          name="Number of Students"
          range={[100, 1000]}
        />
        <Tooltip
          itemStyle={{ color: Colors.PURPLE }}
          cursor={{ strokeDasharray: "3 3" }}
        />
        <Scatter data={data} fill={Colors.ORANGE} isAnimationActive={false} />
      </ScatterChart>
    </ResponsiveContainer>
  );
}
